import { rootApi } from '../rootApi';

export const vehicleWarrantyClaimsReportSumApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getVehicleWarrantyClaimsReportSum: builder.query({
            query: (body) => ({
                url: 'v1/vehiclewarrantyinformation/getwarrantyreportsum',
                method: 'POST',
                body: {
                    pageSize: body?.pageSize ?? 10,
                    pageNumber: body?.pageNumber ?? 1,
                    filters: body?.filters ?? null,
                    sorts: body?.sorts ?? null
                }
            }),
            transformResponse: (response) => {
                if (response?.data && Array.isArray(response.data.items)) {
                    return {
                        items: response.data.items,
                        totalCount: response.data.totalCount ?? 0,
                        filterOptions: response.data.filterOptions ?? null
                    };
                }
                return { items: [], totalCount: 0, filterOptions: null };
            },
            providesTags: ['VehicleWarrantyClaimsReportSum']
        }),
        exportVehicleWarrantyClaimsReportSumToExcel: builder.query({
            query: (body) => ({
                url: 'v1/vehiclewarrantyinformation/exportwarrantyreportsumtoexcel',
                method: 'POST',
                body: {
                    filters: body?.filters ?? null,
                    sorts: body?.sorts ?? null,
                    compressionType: body?.compressionType ?? 0
                }
            }),
            transformResponse: (response) => {
                if (response?.isSuccessful && response?.data) {
                    const { fileBase64, fileName, contentType, recordCount, isCompressed, compressionType } = response.data;
                    return { fileBase64, fileName, contentType, recordCount, isCompressed, compressionType };
                }
                throw new Error(response?.errorMessage || response?.message || 'Export failed');
            }
        })
    }),
    overrideExisting: false
});

export const { useGetVehicleWarrantyClaimsReportSumQuery, useLazyExportVehicleWarrantyClaimsReportSumToExcelQuery } = vehicleWarrantyClaimsReportSumApi;
